import device from 'device'

// mobile components
import Map from './Map'
import Welcome from './Welcome'
import Search from './Search'
import Settings from './Settings'
import SettingsLang from './SettingsLang'
import SettingsMap from './SettingsMap'
import SettingsTerms from './SettingsTerms'
import Article from './Article'
import Route from './Route'

// mobile routes
const routesMobile = {
  home: { path: '/', component: Map },
  welcome: { path: '/welcome', component: Welcome },
  search: { path: '/search', component: Search },
  settings: { path: '/settings', component: Settings },
  settingsLang: { path: '/settingslang', component: SettingsLang },
  settingsMap: { path: '/settingsmap', component: SettingsMap },
  SettingsTerms: { path: '/settingsterms', component: SettingsTerms },
  Article: { path: '/article/:marker', component: Article },
  Route: { path: '/route', component: Route }
}

// desktop routes
const routesDesktop = {
  // home: {
  //   path: '/',
  //   async (routeTo, routeFrom, resolve, reject) {
  //     const vueComponent = () => import('./Desktop')
  //     vueComponent().then(vc => {
  //       resolve({ component: vc.default })
  //     })
  //   }
  // }
}

// routes depending on user device
const userDevice = device(navigator.userAgent)
let routes = userDevice.is('desktop')
  ? Object.assign(routesMobile, routesDesktop)
  : routesMobile
routes = Object.values(routes)

export default routes
